import { Button } from "@wags/ui/button.tsx";
import { Skeleton } from "skullet/react";
import { Header } from "@/components/Header";
import { BREED_BACK_LINK_CLASS, BreedPageBody } from "./breed-page-body";

const SAMPLE_BREED_NAME = "Golden Retriever";

export function BreedPageSkeleton() {
    return (
        <>
            <Header className="bg-true-white" />
            <div className="min-h-dvh w-full bg-maltese-white pt-23.25">
                <Skeleton loading label="Loading breed">
                    <BreedPageBody
                        breedName={SAMPLE_BREED_NAME}
                        backLink={
                            <span className={BREED_BACK_LINK_CLASS}>
                                Back to browse
                            </span>
                        }
                        searchButton={
                            <Button className="w-fit">
                                Search {SAMPLE_BREED_NAME}
                            </Button>
                        }
                    />
                </Skeleton>
            </div>
        </>
    );
}
